import { fromJS } from 'immutable';

export default {
    setUsers: (state, users) => {
        return state.setIn(['list'], fromJS(users)).set('initialized', true);
    },
    updateHomeUsers: (state, homeUsers) => {
        return state.mergeDeepIn(['list'], fromJS(homeUsers));
    },
    deleteUser: (state, userId) => {
        return state.deleteIn(['list', userId.toString()]);
    },
    deleteAndUpdateUser: (state, userId, homeUsers) => {
        return state.deleteIn(['list', userId.toString()]).mergeDeepIn(['list'], fromJS(homeUsers));
    }
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Users/core.js